module.exports = __webpack_public_path__ + "media/images/featured-products/debt-modeller-f9020aafb4c9e6f5b51f68781083c3f6.svg";